<template>
  <el-container class="wrapper-section-cover">
    <el-main>
      <div class="breadcrumb-container">
        <LadBreadcrumbItems />
      </div>

      <h1 class="title">{{ $t(`${base}.title`, { name: country.name }) }}</h1>

      <div class="reviews">
        <div class="wrapper-images">
          <img
            v-for="(url, i) in urls"
            :key="i"
            :src="url"
            :alt="'Profile ' + (i + 1)"
          />
        </div>

        <div class="rating">
          <el-rate
            v-model="rating.value"
            disabled
            show-score
            text-color="#FFF"
          />
          <p>{{ $t(`${base}.reviews`, { total: rating.total }) }}</p>
        </div>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'LadSearchCover',
  components: {
    LadBreadcrumbItems: () =>
      import(
        /* webpackChunkName: "lad-breadcrumb-items" */ '@/components/breadcrumb/components/items'
      ),
  },
  data() {
    return {
      base: 'search.country.cover',
    }
  },
  computed: {
    ...mapState('country', {
      country: (state) => ({ name: state.header.name }),
      rating: (state) => ({
        value: state.country.average_score,
        total: state.country.total_reviews,
      }),
      urls: (state) => {
        const items = state.reviews.map(
          (review) => review._user.profile.avatar.src
        )

        /** se necesitan 7 urls */
        if (items.length > 3) {
          items.push(items[2])
        }

        return items
      },
    }),
    randomuser() {
      const baseUrl = 'https://randomuser.me/api/portraits/'
      const genders = ['women', 'men']
      const urls = []

      for (let i = 0; i < 7; i++) {
        const gender = genders[Math.floor(Math.random() * genders.length)]
        const number = Math.floor(Math.random() * 100)
        urls.push(`${baseUrl}${gender}/${number}.jpg`)
      }

      return urls
    },
  },
}
</script>

<style lang="scss">
.wrapper-search-cover {
  display: flex;
  flex-direction: column;
  height: 330px;
  color: white;

  .section-1,
  .section-3 {
    flex: 1;
  }

  .section-2 {
    flex: 0;
    max-height: 100%;

    .wrapper-images {
      padding-left: 10px;
    }

    .reviews {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      position: relative;

      .rating {
        margin-left: 20px;

        p {
          margin: 0;
          color: white;
        }

        .el-rate__icon {
          font-size: 24px;
          margin-right: 0;
        }
      }

      img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        border: 1px solid white;
        margin: 0 -5px; /* Superposición */
        position: relative;
        z-index: 1;
        background-color: white;

        &:nth-child(2) {
          z-index: 2;
        }
        &:nth-child(3) {
          z-index: 3;
        }
        &:nth-child(4) {
          z-index: 4;
        }
        &:nth-child(5) {
          z-index: 5;
        }
        &:nth-child(6) {
          z-index: 6;
        }
        &:nth-child(7) {
          z-index: 7;
        }
      }
    }

    .breadcrumb-container {
      .el-breadcrumb__inner,
      .el-breadcrumb__inner a,
      .el-breadcrumb__inner.is-link,
      .el-breadcrumb__separator {
        color: white;
      }
    }

    .title {
      font-size: 56px;
      font-weight: 700;
      line-height: 1.8;
      margin: 0;
    }
  }

  @media screen and (max-width: 768px) {
    height: 270px;

    .section-2 {
      padding: 0 20px;

      .reviews {
        flex-direction: column;
        align-items: start;
        row-gap: 10px;

        img {
          width: 32px;
          height: 32px;
          margin: 0 -5px; /* Superposición */
        }

        .rating {
          margin-left: 0;
        }
      }

      .title {
        font-size: 32px;
        font-weight: 700;
        line-height: 2.5;
      }
    }
  }
}
</style>
